"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDeviceDetect = require("react-device-detect");

var _spinner = _interopRequireDefault(require("./spinner"));

require("../css/button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      loading = _ref.loading,
      name = _ref.name,
      appearance = _ref.appearance,
      props = _objectWithoutProperties(_ref, ["className", "children", "disabled", "expanded", "loading", "name", "appearance"]);

  var buttonClasses = {
    'vn-button': true,
    'vn-button--expanded': expanded,
    'vn-button--loading': loading,
    'vn-button--primary': appearance !== 'secondary' && appearance !== 'critical',
    'vn-button--primary--hoverable': appearance !== 'secondary' && appearance !== 'critical' && !_reactDeviceDetect.isMobile,
    'vn-button--secondary': appearance === 'secondary',
    'vn-button--secondary--hoverable': appearance === 'secondary' && !_reactDeviceDetect.isMobile,
    'vn-button--critical': appearance === 'critical',
    'vn-button--critical--hoverable': appearance === 'critical' && !_reactDeviceDetect.isMobile
  };

  if (className) {
    buttonClasses[className] = true;
  }

  return _react.default.createElement("button", _extends({
    id: name,
    type: "button"
  }, props, {
    className: (0, _classnames.default)(buttonClasses),
    disabled: disabled || loading
  }), children, loading === true && _react.default.createElement(_spinner.default, {
    className: "vn-button__spinner",
    size: 24
  }));
};

Button.propTypes = {
  appearance: _propTypes.default.oneOf(['secondary', 'critical']),
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  expanded: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  name: _propTypes.default.string,
  onClick: _propTypes.default.func,
  type: _propTypes.default.oneOf(['submit', 'reset', 'button'])
};
Button.defaultProps = {
  appearance: undefined,
  className: undefined,
  disabled: false,
  expanded: false,
  loading: false,
  name: '',
  onClick: function onClick() {},
  type: 'button'
};
Button.displayName = 'Button';
var _default = Button;
exports.default = _default;